import IdvFooter from './IdvFooter';

export default IdvFooter;
